import React from 'react';
/** Junior male data — owned by this section. */
const MALE = [{
  category: '- 45 Kg / 99 lbs',
  size: '#1',
  level: '22'
}, {
  category: '- 48 Kg / 106 lbs',
  size: '#2',
  level: '23'
}, {
  category: '- 51 Kg / 112 lbs',
  size: '#2',
  level: '24'
}, {
  category: '- 55 Kg / 121 lbs',
  size: '#2',
  level: '25'
}, {
  category: '- 59 Kg / 130 lbs',
  size: '#3',
  level: '27'
}, {
  category: '- 63 Kg / 139 lbs',
  size: '#3',
  level: '28'
}, {
  category: '- 68 Kg / 150 lbs',
  size: '#3',
  level: '30'
}, {
  category: '- 73 Kg / 161 lbs',
  size: '#3',
  level: '32'
}, {
  category: '- 78 Kg / 172 lbs',
  size: '#4',
  level: '33'
}, {
  category: '+ 78 Kg / 172 lbs',
  size: '#4',
  level: '34'
}];
/** Junior female data — owned by this section. */
const FEMALE = [{
  category: '- 42 Kg / 93 lbs',
  size: '#1',
  level: '20'
}, {
  category: '- 44 Kg / 97 lbs',
  size: '#1',
  level: '21'
}, {
  category: '- 46 Kg / 101 lbs',
  size: '#1',
  level: '22'
}, {
  category: '- 49 Kg / 108 lbs',
  size: '#2',
  level: '22'
}, {
  category: '- 52 Kg / 115 lbs',
  size: '#2',
  level: '23'
}, {
  category: '- 55 Kg / 121 lbs',
  size: '#2',
  level: '24'
}, {
  category: '- 59 Kg / 130 lbs',
  size: '#3',
  level: '25'
}, {
  category: '- 63 Kg / 139 lbs',
  size: '#3',
  level: '26'
}, {
  category: '- 68 Kg / 150 lbs',
  size: '#3',
  level: '28'
}, {
  category: '+ 68 Kg / 150 lbs',
  size: '#4',
  level: '30'
}];
type Row = {
  category: string;
  size: string;
  level: string;
};
/**
 * Junior Level tables (male + female). Owns its own data and table markup.
 */
export function JuniorLevel() {
  return <div className="space-y-12" data-id="element-866">
      <Table title="Junior MALE (남자)" headerBg="bg-blue-600" rows={MALE} data-id="element-867" />
      <Table title="Junior FEMALE (여자)" headerBg="bg-pink-600" rows={FEMALE} data-id="element-868" />
    </div>;
}
/* Private helper local to this section — not shared. */
function Table({
  title,
  headerBg,
  rows
}: {
  title: string;
  headerBg: string;
  rows: Row[];
}) {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-869">
      <div className={`${headerBg} px-6 py-4`} data-id="element-870">
        <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-871">
          {title}
        </h2>
      </div>
      <div data-id="element-872">
        <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-873">
          <tbody data-id="element-874">
            <tr className="border-b border-gray-200 bg-gray-50" data-id="element-875">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-876">
                Category
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 text-gray-600 font-medium" data-id="element-877">
                  {item.category}
                </td>)}
            </tr>
            <tr className="border-b border-gray-200" data-id="element-878">
              <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-879">
                Size EBP
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-880">
                  {item.size}
                </td>)}
            </tr>
            <tr className="bg-gray-50" data-id="element-881">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-882">
                LEVEL
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-883">
                  {item.level}
                </td>)}
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}